<template>
   <div>
      <v-card>
         <v-card-title>Election: MIP National Council</v-card-title>
         <v-card-subtitle>
            E-Voting Results<br>
            Status: Ended<br>
            Winner: Tony Otwell with 70 votes<br>
            Total Registered Voters: 150 (Voted: 150)
         </v-card-subtitle>
         <v-divider></v-divider>
         <v-card-text>
            <v-row>
               <v-col cols="3">
                  <v-card color="green lighten-3">
                     <v-img src="/images/1.jpg"/>
                     <v-card-title>Tony Otwell</v-card-title>
                     <v-card-subtitle>1st Place</v-card-subtitle>
                     <v-card-text class="d-flex justify-center">
                        <div class="headline" style="color: green;">70 votes</div>
                     </v-card-text>
                  </v-card>
               </v-col>
               <v-col cols="3">
                  <v-card color="blue lighten-4">
                     <v-img src="/images/6.jpg"/>
                     <v-card-title>Angelina Tay</v-card-title>
                     <v-card-subtitle>2nd Place</v-card-subtitle>
                     <v-card-text class="d-flex justify-center">
                        <div class="headline" style="color: green;">30 votes</div>
                     </v-card-text>
                  </v-card>
               </v-col>
               <v-col cols="3">
                  <v-card color="blue lighten-4">
                     <v-img src="/images/2.jpg"/>
                     <v-card-title>Mark Rogers</v-card-title>
                     <v-card-subtitle>3rd Place</v-card-subtitle>
                     <v-card-text class="d-flex justify-center">
                        <div class="headline" style="color: green;">27 votes</div>
                     </v-card-text>
                  </v-card>
               </v-col>
               <v-col cols="3">
                  <v-card color="blue lighten-4">
                     <v-img src="/images/4.jpg"/>
                     <v-card-title>Gillian Rosemary</v-card-title>
                     <v-card-subtitle>4th Place</v-card-subtitle>
                     <v-card-text class="d-flex justify-center">
                        <div class="headline" style="color: green;">23 votes</div>
                     </v-card-text>
                  </v-card>
               </v-col>
            </v-row>
         </v-card-text>
      </v-card>
   </div>
</template>

<script>
export default {
   name: "PanelVoting"
}
</script>
